import cn from 'classnames';
import styles from './progressBar.module.scss';

type ProgressBarProps = {
  percentage: string;
  outerClassName?: string;
  innerClassName?: string;
  classNameType?: string;
};

const ProgressBar = ({ percentage = '0%', innerClassName, outerClassName, classNameType = 'baseDisplayWithPercentage' }: ProgressBarProps) => {
  const barWidthStyle = { width: percentage };

  return (
    <div className={cn(outerClassName, styles.progressBarWrapper)}>
      <div className={cn(innerClassName, styles.bar, styles[classNameType])} style={barWidthStyle}>
        <span className={styles.percentageText}>{percentage}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
